const NewTagPill = ({ width = 21, height = 11, className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    className={className}
    data-palette="NewTagPill">
    <rect width={21} height={10} y={0.714} fill="#F5A507" rx={1} />
    <path
      fill="#101013"
      d="M7.32 8.714H6.056L3.608 4.162c.024.632.032 1.344.032 1.912v2.64h-.88v-5.52H4l2.472 4.584a80.952 80.952 0 0 1-.024-1.928V3.194h.864l.008 5.52Zm4.786-2.232c0 .08 0 .2-.016.352H9.042c.072 1.016.536 1.352 1.112 1.352.512 0 .912-.312 1-.848h.888c-.184 1.008-.992 1.488-1.92 1.488-1.136 0-1.992-.72-1.992-2.224 0-1.344.856-2.248 2.08-2.248 1.232 0 1.896.928 1.896 2.128Zm-1.928-1.488c-.6 0-1.032.408-1.128 1.224h2.152c-.064-.784-.408-1.224-1.024-1.224Zm8.637-.528-1.352 4.248h-1.008l-.84-3.432-.848 3.432H13.75l-1.352-4.248h.992l.872 3.464.824-3.456h1.072l.848 3.464.872-3.472h.936Z"
    />
  </svg>
);
export default NewTagPill;
